export default __webpack_public_path__ + "static/media/g13.fd3eaf07.jpg";